import React from "react";
import { Card, Typography, Row, Col, Space, Tooltip, Grid } from "antd";
import PropTypes from "prop-types";
import styles from "./styles.scss";

const { Text } = Typography;

const { useBreakpoint } = Grid;

const UserDetailsCard = (props) => {
  const { userDetails, title = "User Details" } = props;
  const screens = useBreakpoint();

  const fieldsKeyTitleMap = [
    {
      key: "email",
      title: "Email Id",
      colSize: 5,
    },
    {
      key: "firstName",
      title: "First Name",
      colSize: 5,
    },
    {
      key: "lastName",
      title: "Last Name",
      colSize: 5,
    },
    {
      key: "phoneNumber",
      title: "Phone number",
      colSize: 5,
    },
    {
      key: "id",
      title: "User ID",
      colSize: 4,
    },
  ];

  return (
    <Card className={styles["user-details-card"]}>
      <div>
        <Text className={styles["user-details-card__header"]} strong>
          {title}
        </Text>
      </div>
      <Row>
        {fieldsKeyTitleMap.map(({ key, title, colSize }) => {
          return (
            <Col key={key} xs={24} lg={colSize}>
              <Space
                className={styles["user-details__space"]}
                direction={screens.lg ? "vertical" : "horizontal"}
                size={0}
              >
                <Text className={styles["user-details__title"]} ellipsis>
                  {title}
                </Text>
                <Tooltip title={userDetails[key] ?? ""}>
                  <Text
                    className={styles["user-details__value"]}
                    ellipsis
                    style={{
                      maxWidth: screens.xl
                        ? "220px"
                        : screens.lg
                        ? "170px"
                        : "400px",
                    }}
                  >
                    {userDetails[key] ?? ""}
                  </Text>
                </Tooltip>
              </Space>
            </Col>
          );
        })}
      </Row>
    </Card>
  );
};

UserDetailsCard.propTypes = {
  userDetails: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    email: PropTypes.string,
    phoneNumber: PropTypes.string,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }),
  title: PropTypes.string,
};

export default UserDetailsCard;
